import { ComponentProps, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutline, ContentCopyOutlined } from '@mui/icons-material';
import { Button } from 'melp-design/components';

interface Props {
  value: string;
  size?: ComponentProps<typeof Button>['size'];
}

export const CopyButton: FC<Props> = ({ value, size = 'md' }) => {
  const { t } = useTranslation();

  const [isCoppied, setIsCoppied] = useState(false);

  useEffect(() => {
    if (isCoppied) {
      const timeoutId = setTimeout(() => {
        setIsCoppied(false);
      }, 2000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isCoppied]);

  const onCopy = async () => {
    await navigator.clipboard.writeText(value);
    setIsCoppied(true);
  };

  return (
    <Button
      icon={isCoppied ? CheckCircleOutline : ContentCopyOutlined}
      variant={isCoppied ? 'secondary' : 'neutral-fill'}
      type="button"
      onClick={isCoppied ? undefined : onCopy}
      tooltip={
        isCoppied ? t('common.copied') : t('employees.copyCategoryValue')
      }
      size={size}
    />
  );
};
